import { LOCKER_REVEAL_STORAGE_PREFIX } from '@/lib/utils';

/**
 * 라커 비밀번호 전역 공개 토글의 저장소.
 *
 * 장부와 대조할 때는 화면 전체를 한 번에 봐야 해서 필요하지만, 평소에는 꺼져 있어야 한다.
 * 그래서 **기본값은 항상 꺼짐**이고, 읽기에 실패하면(사생활 보호 모드 등) 꺼진 것으로 본다.
 *
 * 센터마다 키를 나눈다. 한 계정이 센터를 옮겨 다녀도 앞 센터에서 켠 공개가 따라가지 않는다.
 * 로그아웃 시 제거는 `lib/utils.ts` 의 `clearLocalStorage()` 가 맡는다.
 */

const keyOf = (centerId: string) => `${LOCKER_REVEAL_STORAGE_PREFIX}${centerId}`;

export const readLockerReveal = (centerId?: string | null): boolean => {
    if (!centerId) return false;
    try {
        return sessionStorage.getItem(keyOf(centerId)) === 'true';
    } catch {
        return false;
    }
};

export const writeLockerReveal = (centerId: string | null | undefined, revealed: boolean) => {
    if (!centerId) return;
    try {
        if (revealed) sessionStorage.setItem(keyOf(centerId), 'true');
        else sessionStorage.removeItem(keyOf(centerId));
    } catch {}
};
